import { render, staticRenderFns } from "./AddAccessRight.vue?vue&type=template&id=714c2054&"
import script from "./AddAccessRight.vue?vue&type=script&lang=js&"
export * from "./AddAccessRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports